module.exports = __webpack_public_path__ + "static/media/pk.c519e9b1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pk.svg
// module id = 1010
// module chunks = 0